import React from "react"

import ConfigurationForm from "./ConfigurationForm"
import VersionForm from "./VersionForm"
import ReleaseForm from "./ReleaseForm"
import EventBundleFrom from "./EventBundleForm"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons"
import { User } from "../../../CheckLogin"
class ConfigureBuild extends React.Component{
    render(){
        const { projectId, appConfig, isAdmin } = this.props
        return (
            <div className="configureBuild">
                <h1 className="formTitle">
                    App Config
                </h1>
                <User.Consumer>
                {
                    (user) => <ConfigurationForm 
                        projectId={projectId} 
                        appConfig={appConfig} 
                        isAdmin={isAdmin} 
                        getAppConfig={this.props.getAppConfig} 
                        user={user}/>
                }
                </User.Consumer>
                {appConfig[0].approved === true
                ? <>
                    <h1 className="formTitle">
                        Asset Bundle Patches
                    </h1>
                    <ReleaseForm projectId={projectId} appConfig={appConfig[0]} appConfigId={appConfig[0].id}/>
                    <h1 className="formTitle">
                        Event Bundles
                    </h1>
                    <EventBundleFrom projectId={projectId} appConfig={appConfig[0]} appConfigId={appConfig[0].id}/>
                    <h1 className="formTitle">
                        Builds
                    </h1>
                    <VersionForm projectId={projectId} appConfig={appConfig[0]} appConfigId={appConfig[0].id}/>
                </>
                : null}
                </div>
        )
    }
}

export default ConfigureBuild